<template>
  <div class="previewLinesComponent">
      <app-previewline v-for="line in label.lines" :line="line" :label="label" ></app-previewline>
  </div>
</template>
<script>
    import PreviewLine from './Previewline';

    export default {
        props : ['label'],
        components : {
            appPreviewline : PreviewLine
        }

    }
</script>
<style>
    .previewLinesComponent {
        width   : 100%;
        display : inline-block;
        height  : 100%;
        position: absolute;
        top:0px;
        left:0px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Preview/Previewlines.vue